module.exports = __webpack_public_path__ + "img/geod_1.71616c6f.jpg";